import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
import { IconArrowDown } from '../../../icons/svg';
import { withPixelLineHeight } from '../../../styles/functions.web';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column'
        },
        label: {
            color: theme.palette.text01,
            ...withPixelLineHeight(theme.typography.bodyShortRegular),
            marginBottom: theme.spacing(2),
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyShortRegularLarge)
            }
        },
        leftIcon: {
            position: 'absolute',
            top: '8px',
            left: '12px',
            pointerEvents: 'none',
            '&.is-mobile': {
                top: '14px',
                left: '12px'
            }
        },
        selectContainer: {
            position: 'relative'
        },
        select: {
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '5px',
            width: '100%',
            fontFamily: 'Lato Regular',
            fontWeight: 'normal',
            fontSize: '15px',
            lineHeight: '18px',
            color: 'rgba(255, 255, 255, 1)',
            padding: '8px 12px',
            paddingRight: '34px',
            border: 0,
            appearance: 'none',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&:focus': {
                outline: 0,
            },
            '&:disabled': {
                color: theme.palette.text03
            },
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyShortRegularLarge),
                padding: '12px 16px',
                paddingRight: '46px'
            },
            '&.is-left-icon': {
                paddingLeft: '38px',
            },
            '&.error': {
                boxShadow: `0px 0px 0px 2px ${theme.palette.textError}`
            }
        },
        option: {
            backgroundColor: theme.palette.ui11,
        },
        icon: {
            position: 'absolute',
            top: '8px',
            right: '8px',
            pointerEvents: 'none',
            '&.is-mobile': {
                top: '12px',
                right: '12px'
            }
        },
        bottomLabel: {
            marginTop: theme.spacing(2),
            ...withPixelLineHeight(theme.typography.labelRegular),
            color: theme.palette.text02,
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyShortRegular)
            },
            '&.error': {
                color: theme.palette.textError
            }
        }
    };
});
const Select = ({ bottomLabel, className, disabled, error, id, label, icon, onChange, options, value }) => {
    const { classes, cx, theme } = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("div", { className: classes.container },
        label && React.createElement("label", { className: cx(classes.label, isMobile && 'is-mobile'), htmlFor: id }, label),
        React.createElement("div", { className: classes.selectContainer },
            icon && (React.createElement(Icon, { className: cx(classes.leftIcon, isMobile && 'is-mobile'), color: disabled ? theme.palette.icon03 : 'rgba(255, 255, 255, 0.75)', size: 18, src: icon })),
            React.createElement("select", { "aria-describedby": bottomLabel ? `${id}-description` : undefined, className: cx(classes.select, isMobile && 'is-mobile', className, error && 'error', icon && 'is-left-icon'), disabled: disabled, id: id, onChange: onChange, value: value }, options.map(option => (React.createElement("option", { key: option.value, value: option.value, className: classes.option }, option.label)))),
            React.createElement(Icon, { className: cx(classes.icon, isMobile && 'is-mobile'), color: disabled ? theme.palette.icon03 : 'rgba(255, 255, 255, 0.75)', size: 18, src: IconArrowDown })),
        bottomLabel && (React.createElement("span", { className: cx(classes.bottomLabel, isMobile && 'is-mobile', error && 'error'), id: `${id}-description` }, bottomLabel))));
};
export default Select;
